<template>
    <section
        v-if="mounted"
        class="DefaultHero lazyload"
        :class="classes"
        :data-bgset="images && images.length > 1 ? '' : image"
    >
        <PageBuilderImages
            v-if="images && images.length > 1"
            :images="images"
            :speed="5000"
            class="relative"
        />
        <div class="DefaultHero__container container">
            <BaseHeading
                v-if="heading"
                :preheading="preheading"
                :heading="heading"
                tag="h1"
                :classes="{'text--white' : white && image}"
            />
            <slot />
        </div>
    </section>
</template>
<script>
import moment from 'moment';
export default {
    name: 'DefaultHero',
    props: {
        heading: {
            type: String,
        },
        preheading: {
            type: String,
        },
        image: {
            type: String,
            default: ''
        },
        images: {
            type: Array,
            default: null
        },
        white: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            mounted: false
        }
    },
    computed: {
        classes() {
            return {
                'text--black' : !this.white && this.image || this.white && !this.image,
                'text--white' : this.white && this.image,
                'DefaultHero--bg-dark' : this.white && this.image,
                'DefaultHero--bg-bright' : !this.white && this.image,
                'DefaultHero--simple' : !this.image,
                'DefaultHero--small' : this.small,
                'DefaultHero--carousel' : this.images && this.images.length > 1,
            }
        }
    },
    mounted() {
        this.mounted = true;
    }
}
</script>
<style lang="scss" scoped>
    .DefaultHero--carousel {
        height: auto!important;
        padding: 0!important;
    }

    .DefaultHero--carousel .DefaultHero__container {
        position: absolute;
        left: 0;
        right: 0;
        top: 2rem;
        bottom: 2rem;
        height: auto;
    }

    ::v-deep .PageBuilderImages__nav {
        position: absolute;
        bottom: 2rem;
        right: 2rem;
        z-index: 1;

        @include media-query(palm) {
            display: none;
        }
    }

    @include media-query(palm) {
        ::v-deep .PageBuilderImages {
            height: 280px;
        }

        ::v-deep .flickity-enabled,
        ::v-deep .flickity-viewport,
        ::v-deep .flickity-slider,
        ::v-deep .BaseImage {
            height: 100%!important;
        }
    }
</style>
<style lang="scss">
    .DefaultHero {
        position: relative;
        background-size: cover;
        background-position: center;
        padding: getSpacing('medium') 0;
        background-color: $action-color;
        z-index: 0;

        @include media-query(lap-and-up) {
            height: 400px;

            &.small {
                height: 400px;
            }
        }

        @include media-query(desk) {
            height: 600px;
        }
    }

    .DefaultHero--small {
        @include media-query(desk) {
            height: 400px;
        }
    }

    .DefaultHero--noborder {
        padding-bottom: getSpacing(small);
    }

    .DefaultHero--article {
        @include media-query(palm) {
            margin-bottom: getSpacing(medium);
        }
        @include media-query(lap-and-up) {
            margin-bottom: getSpacing(large);
        }
    }

    .DefaultHero--simple {
        height: auto;
        background: none;
        padding-bottom: 0;
    }

    .DefaultHero__container {
        display: flex;
        align-items: flex-end;
        height: 100%;
        min-height: 180px;

        .DefaultHero--simple & {
            padding-bottom: getSpacing('large');
            min-height: auto;
            border-bottom: 1px solid getColour('grey', 'medium');
        }

        .DefaultHero--noborder & {
            border-bottom: 0;

            @include media-query(palm) {
                flex-direction: column;
                align-items: unset;
            }
        }

        .DefaultHero--article & {
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;
            width: 100%;
        }
    }


    .DefaultHero--bg-dark:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-image: linear-gradient(to top right, rgba(0,0,0,0.3), rgba(0,0,0,0));
        z-index: -1;
    }

    .DefaultHero--bg-bright:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-image: linear-gradient(to top right, rgba(255,255,255,0.3), rgba(0,0,0,0));
        z-index: -1;
    }

    .DefaultHero .BaseHeading {
        @include media-query(desk) {
            max-width: 800px;
        }
    }

    .DefaultHero--noborder .BaseHeading {
        @include media-query(palm) {
            margin-bottom: getSpacing(medium);
        }
        @include media-query(lap-and-up) {
            padding-right: getSpacing(xlarge);
        }
    }

    .DefaultHero--article .BaseHeading {
        margin-bottom: getSpacing(spacer);
    }
</style>
